import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="color-picker"
export default class extends Controller {
  
  static targets = ["input", "button", "text", "clear", "close"]
  
  select(e) {
    const color = e.currentTarget.dataset.color
    const tint = parseInt(color.split("-")[1], 10)
    const textColor = tint >= 400 ? "white" : "gray-700"
    this.inputTarget.value = color
    this.buttonTarget.classList = `color-picker-button bg-${color} text-${textColor} border-none`
    this.textTarget.innerText = color
    this.clearTarget.classList = `color-picker-clear text-${textColor}`
    this.dispatch("color:select", { detail: { color } })
  }

  clear(e) {
    e?.preventDefault()
    e?.stopImmediatePropagation()
    this.inputTarget.value = ""
    this.buttonTarget.classList = "color-picker-button bg-transparent text-gray-500"
    this.textTarget.innerText = "Sélectionner une couleur"
    this.clearTarget.classList = `color-picker-clear`
    this.close()
    this.dispatch("color:clear")
  }

  close() {
    this.closeTarget.click()
  }

  disconnect() {
    this.clear()
  }
  
}
